<template>
  <div class="formdata owner">
    <div class="header-container">
    <h3 id="wish_power_storage_question">Möchten Sie einen Stromspeicher für die PV-Anlage?</h3>
</div>
    <CustomRadioGroup
        :options="wishPowerStorageAnswers"
        v-model="selectedAnswer"
        aria-labelledby="wish_power_storage_question"
        @optionSelected="submit"
    >
      <template #option="{ option }">
        <label :for="'wish_power_storage_' + option.value">
          <img :src="option.image" alt="" aria-hidden="true" />
          <p>{{ option.name }}</p>
        </label>
      </template>
    </CustomRadioGroup>

    <button
        class="button button_yellow right"
        v-if="selectedAnswer"
        @click="submit"
    >
      Weiter
    </button>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { useWorkflowStore } from '@/stores/workflow';
import { wishPowerStorageAnswers, wishPowerStorageApi } from '@/data/wishPowerStorageData.js';
import CustomRadioGroup from '@/components/CustomRadioGroup.vue';

const workflowStore = useWorkflowStore();

const getAnswerEventData = (selectedValue) => {
  const fullAnswer = wishPowerStorageAnswers.find(bt => bt.value === selectedValue);

  if (fullAnswer) {
    return {
      value: selectedValue,
      apiDefinition: wishPowerStorageApi,
      apiValue: fullAnswer.api,
      available: fullAnswer.available,
    };
  }
  return null;
};

const selectedAnswer = computed({
  get() {
    return workflowStore.workflowContext.formData.building?.wish_power_storage || null;
  },
  set(newValue) {
    const eventData = getAnswerEventData(newValue);
    workflowStore.sendWorkflowEvent({
      type: 'UPDATE_SELECTED_WISH_POWER_STORAGE_ANSWER',
      data: eventData,
    });
  },
});

const submit = () => {
  if (selectedAnswer.value) {
    const eventData = getAnswerEventData(selectedAnswer.value);
    workflowStore.sendWorkflowEvent({
      type: 'NEXT',
      data: eventData,
    });
  }
};


</script>

